export default {
  titleStep: {
    id: 'trade_in_au_step_title',
    defaultMessage: 'Get this for even less with Trade-in',
  },
  swapCardGuidance: {
    id: 'trade_in_au_card_guidance',
    defaultMessage: 'See how Trade-in works',
  },
}
